const strings = {
  labels: {
    unknownCustomer: 'Unknown Customer',
    endSessionButton: 'End Session',
    messageOptionsButton: 'Message options',
    actionMenu: {
      markAsUnread: 'Mark as unread',
      blockSpam: 'Block Spam',
    },
    blockSpamDialog: {
      title: 'Confirmation',
      body: 'Are you sure you want to add this number to the blocked list and permanently close this thread?',
      primaryAction: 'Block Spam',
      secondaryAction: 'Close',
    },
    toasts: {
      blockSpamSuccess: 'Contact has been added to the Blocked List.',
      endSessionSuccess: 'Message Session has been ended.',
    },
  },
} as const;

export default strings;
